<template>
  <span class="badge" :class="typeClass">
    {{ type }}
  </span>
</template>
<script setup lang="ts">
import { defineProps, computed } from 'vue';
const props = defineProps<{ type: string }>();
const typeClass = computed(() => {
  switch (props.type) {
    case 'scheduled': return 'bg-blue-100 text-blue-700';
    case 'repair': return 'bg-red-100 text-red-700';
    case 'inspection': return 'bg-yellow-100 text-yellow-700';
    default: return 'bg-gray-100 text-gray-700';
  }
});
</script>
<style scoped>
.badge {
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.85rem;
  font-weight: 500;
  display: inline-block;
}
</style>
